import { useCallback, useMemo } from 'react';
import { Form } from 'react-final-form';

import { RetailerNetworkFragment } from '@occc/graphql';

import { RetailerNetworkConfigurationForm } from './retailer-network-configuration-form.component';
import {
  RetailerNetworkConfigurationFormInitialValues,
  RetailerNetworkConfigurationFormProps,
  RetailerNetworkConfigurationFormRenderProps,
  RetailerNetworkConfigurationFormValues,
} from './retailer-network-configuration.types';
import { getInitialValues } from './retailer-network-configuration.utils';
import { validateRetailerNetworkConfiguration } from './retailer-network-configuration.validation';

import { useBreadcrumbLinks } from '../hooks/use-breadcrumb-links.hook';

type RetailerNetworkConfigurationProps = {
  onSubmit: RetailerNetworkConfigurationFormProps['onSubmit'];
  retailerNetwork?: RetailerNetworkFragment;
};

const RetailerNetworkConfiguration = ({
  onSubmit,
  retailerNetwork,
}: RetailerNetworkConfigurationProps) => {
  useBreadcrumbLinks();

  const initialValues = useMemo(() => getInitialValues(retailerNetwork), [retailerNetwork]);

  const renderRetailerNetworkConfigurationForm: RetailerNetworkConfigurationFormProps['render'] =
    useCallback(
      ({
        handleSubmit,
        valid,
        submitting,
        values,
        form,
      }: RetailerNetworkConfigurationFormRenderProps) => {
        return (
          <RetailerNetworkConfigurationForm
            handleSubmit={handleSubmit}
            disabled={!valid || submitting}
            customerId={values.customerId}
            numberOfLocations={retailerNetwork?.numberOfLocations}
            retailerNetworkUuid={retailerNetwork?.uuid}
            membersPerStoreGoal={values?.monthlyPerformanceGoal?.membersPerStore}
            transactionsPerStoreGoal={values?.monthlyPerformanceGoal?.transactionsPerStore}
            form={form}
          />
        );
      },
      [retailerNetwork?.numberOfLocations, retailerNetwork?.uuid],
    );
  return (
    <Form<RetailerNetworkConfigurationFormValues, RetailerNetworkConfigurationFormInitialValues>
      onSubmit={onSubmit}
      initialValues={initialValues}
      render={renderRetailerNetworkConfigurationForm}
      validate={validateRetailerNetworkConfiguration}
    />
  );
};

export default RetailerNetworkConfiguration;
